import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2c1cff54&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./style/index.scss?vue&type=style&index=0&id=2c1cff54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1cff54",
  null
  
)

export default component.exports